import { faRotateLeft, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IAny } from '~/helpers/types';
import type { IUsePersistentFormResult } from './usePersistentForm';
import { Callout } from '~/components/molecules/Callout';

export type IPersistentFormBannerProps = IContainerProps & {
  persistentForm: IUsePersistentFormResult<IAny>;
};

export const PersistentFormBanner: React.FC<IPersistentFormBannerProps> = (
  props,
) => {
  const { persistentForm, sx } = props;
  const { t } = useTranslation();

  return (
    <Callout
      sx={sx}
      variant="emphasized"
      title={t('PersistentFormBanner.title')}
      actions={
        <>
          <Button
            variant="text"
            onClick={() => persistentForm.recover?.()}
            icon={<FontAwesomeIcon icon={faRotateLeft} />}
          >
            {t('PersistentFormBanner.action.recover')}
          </Button>
          <Button
            variant="text"
            onClick={() => persistentForm.discard?.()}
            icon={<FontAwesomeIcon icon={faXmark} />}
          >
            {t('PersistentFormBanner.action.discard')}
          </Button>
        </>
      }
    >
      {t('PersistentFormBanner.text')}
    </Callout>
  );
};
